// src/components/Skeleton.tsx
// Reusable skeleton loading components for better perceived performance

import React from 'react';
import {
  IonCard,
  IonCardContent,
  IonItem,
  IonLabel,
  IonThumbnail,
  IonSkeletonText,
  IonAvatar,
  IonList,
} from '@ionic/react';
import './Skeleton.css';

// Skeleton for user profile cards (Discovery page)
export const ProfileCardSkeleton: React.FC = () => (
  <IonCard className="profile-card-skeleton">
    <div className="skeleton-image-container">
      <IonSkeletonText animated style={{ width: '100%', height: '400px' }} />
    </div>
    <IonCardContent>
      <IonSkeletonText animated style={{ width: '60%', height: '28px', marginBottom: '8px' }} />
      <IonSkeletonText animated style={{ width: '40%', height: '16px', marginBottom: '16px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '14px', marginBottom: '4px' }} />
      <IonSkeletonText animated style={{ width: '90%', height: '14px', marginBottom: '4px' }} />
      <IonSkeletonText animated style={{ width: '80%', height: '14px' }} />
    </IonCardContent>
  </IonCard>
);

// Skeleton for chat list items
export const ChatListSkeleton: React.FC = () => (
  <IonList>
    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
      <IonItem key={i}>
        <IonAvatar slot="start">
          <IonSkeletonText animated />
        </IonAvatar>
        <IonLabel>
          <h2>
            <IonSkeletonText animated style={{ width: '50%' }} />
          </h2>
          <p>
            <IonSkeletonText animated style={{ width: '80%' }} />
          </p>
        </IonLabel>
        <div slot="end">
          <IonSkeletonText animated style={{ width: '40px' }} />
        </div>
      </IonItem>
    ))}
  </IonList>
);

// Skeleton for chat messages
export const ChatMessagesSkeleton: React.FC = () => (
  <div className="chat-messages-skeleton">
    {[1, 2, 3, 4, 5].map((i) => (
      <div key={i} className={`message-skeleton ${i % 2 === 0 ? 'sent' : 'received'}`}>
        <div className="message-bubble-skeleton">
          <IonSkeletonText animated style={{ width: i % 3 === 0 ? '60%' : '80%', height: '14px', marginBottom: '4px' }} />
          <IonSkeletonText animated style={{ width: '40%', height: '14px' }} />
        </div>
      </div>
    ))}
  </div>
);

// Skeleton for profile page
export const ProfilePageSkeleton: React.FC = () => (
  <div className="profile-page-skeleton">
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <IonSkeletonText animated style={{ width: '120px', height: '120px', borderRadius: '50%', margin: '0 auto 16px' }} />
      <IonSkeletonText animated style={{ width: '60%', height: '24px', margin: '0 auto 8px' }} />
      <IonSkeletonText animated style={{ width: '40%', height: '16px', margin: '0 auto' }} />
    </div>
    <IonList>
      {[1, 2, 3, 4, 5].map((i) => (
        <IonItem key={i}>
          <IonLabel>
            <h2>
              <IonSkeletonText animated style={{ width: '40%' }} />
            </h2>
            <p>
              <IonSkeletonText animated style={{ width: '70%' }} />
            </p>
          </IonLabel>
        </IonItem>
      ))}
    </IonList>
  </div>
);

// Skeleton for game cards
export const GameCardSkeleton: React.FC = () => (
  <IonCard className="game-card-skeleton">
    <IonSkeletonText animated style={{ width: '100%', height: '80px' }} />
    <IonCardContent>
      <IonSkeletonText animated style={{ width: '60%', height: '20px', marginBottom: '8px' }} />
      <IonSkeletonText animated style={{ width: '40%', height: '14px', marginBottom: '12px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '12px', marginBottom: '4px' }} />
      <IonSkeletonText animated style={{ width: '90%', height: '12px', marginBottom: '4px' }} />
      <IonSkeletonText animated style={{ width: '80%', height: '12px' }} />
    </IonCardContent>
  </IonCard>
);
